import axios from 'axios';
import { get } from 'lodash';

import { routes } from '../common/utils/routes';
import { storage } from '../common/utils/storage';

const { REACT_APP_API_ENDPOINT, API_TIME_OUT } = process.env;

let baseURL = REACT_APP_API_ENDPOINT;

if (process.env.NODE_ENV === 'development' && baseURL?.startsWith('https://localhost')) {
  baseURL = baseURL.replace('https://', 'http://');
}

const ApiClient = axios.create({
  baseURL,
  timeout: (API_TIME_OUT && parseInt(API_TIME_OUT, 10)) || 30000,
});

ApiClient.interceptors.request.use(
  (config: any) => {
    if (process.env.NODE_ENV === 'development') {
      const currentBaseURL = config.baseURL || ApiClient.defaults.baseURL;
      if (currentBaseURL?.startsWith('https://localhost')) {
        config.baseURL = currentBaseURL.replace('https://', 'http://');
      }
    }

    const authorizationData = storage.getToken();
    if (authorizationData) {
      config.headers.Authorization = `Bearer ${authorizationData}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

ApiClient.interceptors.response.use(
  (response: any) => {
    return response.data;
  },
  (error: any) => {
    const message = get(error, 'response.data.message');

    if (message === 'token.invalid') {
      localStorage.removeItem('persist:root');
      storage.removeToken();
      window.location.pathname = routes.LOGIN;
    }

    return Promise.reject(error);
  },
);

export default ApiClient;
